import React, { useContext, useState, useRef } from 'react';
import { Container, Table, Spinner, Form, Row, Col, InputGroup, Button, Accordion } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


const StaffReportTableItem = ({ data, staffName, getBill, setViewBillModal, downloadExcel, dateRange }) => {
	const tableRef = useRef(null);
	const formatExcel = () => {
		if (data.bills && Object.keys(data.bills).length > 0) {
			let result = [];
			Object.keys(data.bills).map(bill => {
				const b = data.bills[bill];
				result.push({
					'Date': b.bill_date,
					'Time': b.bill_time,
					'Invoice': b.bill_id,
					'Customer': b.customer_name,
					'Phone': b.customer_phone,
					'SC': parseFloat(b.service_amount_total).toFixed(2),
					'TC': parseFloat(b.transaction_total).toFixed(2),
					'Credit': b.credit_amount ?? '-',
					'Credit Status': b.credit_status ? 'Paid' : 'Pending',
					'Total': parseFloat(b.bill_total).toFixed(2)
				});
				return b;
			});
			return result;
		}
	}

	return (
		<Accordion className="mb-2" >
			<Accordion.Item eventKey="0">
				<Accordion.Header><span className="tp1 f18" >{staffName}</span></Accordion.Header>
				<Accordion.Body>
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), `report_staff_${staffName.replace(/\s+/g, '_')}_${dateRange}.xlsx`);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							$('.view-bill-link').addClass('hide');
							generatePDF(tableRef, { filename: `report_staff_${staffName.replace(/\s+/g, '_')}_${dateRange}.pdf` });
							$('.view-bill-link').removeClass('hide');
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
							onBeforeGetContent={() => {
								return new Promise((resolve) => {
									$('.view-bill-link').addClass('hide');
									resolve();
								});
							}}
							onAfterPrint={() => {
								$('.view-bill-link').removeClass('hide');
							}}
						/>
					</div>
					<div ref={tableRef}>
						<Table bordered className="tbl-bg-blue"  >
							<thead>
								<tr>
									<th><span className="tp2" >Date</span></th>
									<th><span className="tp2" >Invoice</span></th>
									<th><span className="tp2" >Customer</span></th>
									<th className="text-end tp2" ><span>SC</span></th>
									<th className="text-end tp2" ><span>TC</span></th>
									<th className="text-end tp2" ><span>Credit</span></th>
									<th className="text-end tp2" >Total</th>
								</tr>
							</thead>
							<tbody>
								{
									data.bills !== undefined ? (
										Object.keys(data.bills).length > 0 ? (
											Object.keys(data.bills).map((bill, bill_i) => (
												<tr key={`bill_${bill_i}`}>
													<td>
														<div className='d-grid'>
															<div className='d-flex align-items-center'>
																<span onClick={() => {
																	getBill(data.bills[bill].bill_id);
																	setViewBillModal(true);
																}} className="view-bill-link mx-0" ><i className="bi bi-receipt"></i> Bill</span>
															</div>
															<span className="tp2 f12">{data.bills[bill].bill_date}, {data.bills[bill].bill_time}</span>
														</div>

													</td>
													<td><span className="tp2">{data.bills[bill].bill_id}</span></td>
													<td>
														<span className="tp2 d-grid">{data.bills[bill].customer_name}</span>
														<span className="tp2 d-grid">{data.bills[bill].customer_phone}</span>

													</td>
													<td className="tp2 text-end"><span>{parseFloat(data.bills[bill].service_amount_total).toFixed(2)}</span></td>
													<td className="tp2 text-end"><span>{parseFloat(data.bills[bill].transaction_total).toFixed(2)}</span></td>
													<td className="tp2 text-end">
														{
															data.bills[bill].credit_amount !== null && data.bills[bill].credit_amount !== "" && data.bills[bill].credit_amount > 0 ? (
																data.bills[bill].credit_status ? (
																	<div className='d-flex align-items-center justify-content-between'>
																		<span className="sucess-tag mx-2"><i className="bi bi-check-circle"></i> Paid</span>
																		<span>{parseFloat(data.bills[bill].credit_amount).toFixed(2)}</span>
																	</div>
																) : (
																	<div className='d-flex align-items-center justify-content-between'>
																		<span className="error-message mx-2"><i className="bi bi-x-circle"></i> Pending</span>
																		<span>{parseFloat(data.bills[bill].credit_amount).toFixed(2)}</span>
																	</div>
																)
															) : '-'
														}
													</td>
													<td className="tp2 text-end"><span>{parseFloat(data.bills[bill].bill_total).toFixed(2)}</span></td>
												</tr>
											))
										) : ''
									) : ''
								}
								<tr>
									<td colSpan={3} className="text-end bgy"><span className='f20' >Total</span></td>
									<td className="text-end bgy" ><span className='f20' >{parseFloat(data.serv_bills_total).toFixed(2)}</span></td>
									<td className="text-end bgy" ><span className='f20' >{parseFloat(data.trans_bills_total).toFixed(2)}</span></td>
									<td className="text-end bgy" ><span className='f20' >{parseFloat(data.credit_bills_total).toFixed(2)}</span></td>
									<td className="text-end bgy" ><span className='f20' >{parseFloat(data.bills_total).toFixed(2)}</span></td>
								</tr>
							</tbody>
						</Table>
					</div>
				</Accordion.Body>
			</Accordion.Item>
		</Accordion >
	);
};

export const StaffReport = () => {
	const { getStaffReport, staffReport, staffReportLoad, getDate, getBill, setViewBillModal, downloadExcel } = useContext(AppContext);
	const [dateRange, setDateRange] = useState('');
	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		if (start !== "" && end !== "") {
			getStaffReport(start, end);
			setDateRange(`From_${start}_To_${end}`);
		}
	}
	return (
		<div className="container-fluid">
			<div className='grid4by6 bgp br-3 p-2 align-items-center justify-content-between mb-2'>
				<div className='px-2'>
					{
						staffReportLoad ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						) : (
							<span>Staff wise invoice report</span>
						)

					}
				</div>
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={4} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>

			{
				staffReport !== undefined ? (
					Object.keys(staffReport).length > 0 ? (
						Object.keys(staffReport).map((staff, s_i) => (
							<StaffReportTableItem
								key={`stfrpt_${s_i}`}
								data={staffReport[staff]}
								staffName={`${staffReport[staff].first_name} ${staffReport[staff].last_name}, Username : ${staffReport[staff].username}`}
								getBill={getBill}
								setViewBillModal={setViewBillModal}
								downloadExcel={downloadExcel}
								dateRange={dateRange}
							/>
						))
					) : 'Not found'
				) : 'Not found!'

			}
		</div>
	)
}